import { Directive, Type } from '@angular/core';

@Directive()
export class TableView {
  constructor(public component: Type<any>) {}
}
